var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPlayPlay = function SvgIconPlayPlay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 15.5a.625.625 0 0 1-.625-.625V1.125a.625.625 0 0 1 .938-.544l11.875 6.875a.625.625 0 0 1 0 1.088L1.688 15.419a.6.6 0 0 1-.313.081M2 2.206v11.588L12 8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlayPlay);
export { ForwardRef as ReactComponent };